import React from 'react';
import { Box } from '@mui/material';
import MyProfile from '../MyProfile';
import ChangePassword from '../ChangePassword';

// Account & Settings › My Account — /account. Profile and password side by side on one page
// (old /account?tab=… links still land here).
const MyAccount = ({ currentUser }) => (
  <Box sx={{ width: '100%', minWidth: 0, maxWidth: 1200, display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 3fr) minmax(0, 2fr)' }, alignItems: 'stretch' }}>
    <MyProfile currentUser={currentUser} />
    <ChangePassword />
  </Box>
);

export default MyAccount;
